import { jsx as _jsx } from "react/jsx-runtime";
import { ClampedTypography } from "../Typographies/ClampedTypography";
export const RecipeAssignmentWrapper = ({ text, onClick }) => (_jsx(ClampedTypography, Object.assign({ variant: "body2", lines: 2, sx: {
        textDecoration: onClick ? "underline" : "none",
        cursor: onClick ? "pointer" : "default",
    }, onClick: onClick, tooltip: true }, { children: text })));
